import { $$ } from '../../../shared/js/utils/dom';

const buttonTranslation = $$('.claim__button');

buttonTranslation.length &&
  buttonTranslation.forEach(button => {
    button.addEventListener('click', event => {
      const container = event.currentTarget.closest('.claim');
      container.classList.toggle('is-translated');
    });
  });
